<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<fuHeader :zxFlag="false" types="home" />
		<div class="searBox">
			<div class="searBoxLeft">
				<div class="searBoxItem">
					<div class="searBoxTop">
						<img src="@/assets/img/wangy.svg" alt="" />
						<span>网页资源</span>
					</div>
					<div class="searBoxBot searBoxBot1">
						<span
							@click="
								tzBtn('zlmwHome', {
									tabType: 3
								})
							"
						>
							美文
						</span>
						<span
							@click="
								tzBtn('zlmwHome', {
									tabType: 2
								})
							"
						>
							演讲
						</span>
						<span
							@click="
								tzBtn('zlmwHome', {
									tabType: 1
								})
							"
						>
							歌曲
						</span>
						<span @click="tzBtn('dianyingHome')">电影</span>
					</div>
				</div>
				<div class="searBoxItem">
					<div class="searBoxTop">
						<img src="@/assets/img/wdzy.svg" alt="" />
						<span>文档资源</span>
					</div>
					<div class="searBoxBot">
						<span @click="tzBtn('gongxiangHz', { yzType: '2', classType: 2, tabFtxt: '最新试卷' })">最新试卷</span>
						<span @click="tzBtn('kejianTj', { tabFtxt: '每期课件' })">每期课件</span>
						<span @click="tzBtn('gongxiangHz', { yzType: '2', classType: 1, tabFtxt: '同步课件' })">同步课件</span>
						<span @click="tzBtn('gongxiangHz', { yzType: '2', classType: 3, tabFtxt: '优质课件' })">优质课件</span>
						<span @click="tzBtn('gongxiangHz', { yzType: '2', classType: 8, treFlag: false, tabFtxt: '双语新闻' })">双语新闻</span>
						<span class="kzydBox">
							<i @click="tzBtn('gongxiangHz', { yzType: '2', classType: 11, treFlag: false, tabFtxt: '扩展阅读' })">扩展阅读</i>
							<div class="searBoxTips">
								<div class="line"></div>
								<div class="searBoxTip">
									<div class="searBoxTipItem" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 5, treFlag: false, tabFtxt: '双语节目' })">双语节目</div>
									<div class="searBoxTipItem" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 6, treFlag: false, tabFtxt: '英文小说' })">英文小说</div>
									<div class="searBoxTipItem" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 4, treFlag: false, tabFtxt: '荐阅外刊' })">荐阅外刊</div>
									<div class="searBoxTipItem" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 7, treFlag: false, tabFtxt: '优质课' })">优质课</div>
								</div>
								<div class="arrow"></div>
							</div>
						</span>
					</div>
				</div>
				<div class="searBoxItem">
					<div class="searBoxTop">
						<img src="@/assets/img/sti.svg" alt="" />
						<span>试题资源</span>
					</div>
					<div class="searBoxBot">
						<span @click="tzBtn('gongxiangHz', { type: 2, classType: 9, tabFtxt: '每日一听' })">每日一听</span>
						<span @click="tzBtn('zystHome', { txt: '高考真题' })">高考真题</span>
						<span @click="tzBtn('tingliHome', { txt: '听力课本' })">听力课本</span>
						<span @click="tzBtn('zystHome', { txt: '高频词汇', tabFlag: 2 })">高频词汇</span>
					</div>
				</div>
			</div>
			<div class="searBoxCont">
				<lunbo :imgArr="bgImgs" lbHeight="312" />
			</div>
			<div class="searBoxRig">
				<div class="searBoxRigXin supHove2" @click="tzBtn('myBanji', { txt: '我的班级', tabFtxt: '首页' })">
					<img src="@/assets/img/jxb.svg" class="icon" alt="" />
					<p>我的教学班</p>
					<img src="@/assets/img/jr.svg" class="iconX" alt="" />
				</div>
				<div class="searBoxRigCont">
					<div class="searBoxRigNr" v-if="bjData">
						<div class="searBoxTit">
							<p>班级管理</p>
							<img src="@/assets/img/jinru.svg" class="supHove3" @click="tzBtn('banjiHome', { txt: '班级管理', id: bjData.id, tabFtxt: '首页' })" alt="" />
						</div>
						<p>
							<span>学校</span>
							{{ infoData.school }}
						</p>
						<p>
							<span>班级</span>
							{{ bjData.name }}
						</p>
						<p>
							<span>班号</span>
							{{ bjData.number }}
						</p>
						<div class="searBoxRigNrBot">
							<i class="el-icon-user-solid"></i>
							<span>班级人数</span>
							<p>
								{{ bjData.peopleNumber }}
								<span>人</span>
							</p>
						</div>
					</div>
					<div class="bjBox" v-else>
						<el-empty :image-size="80" description="暂无班级信息"></el-empty>
					</div>
					<div
						class="searBoxRigBot"
						@click="
							tzBtn('myBanji', {
								cjFlag: 1
							})
						"
					>
						<i class="el-icon-plus"></i>
						<!-- <img src="@/assets/img/tjia.svg" alt=""> -->
						<span>创建新班级</span>
					</div>
				</div>
			</div>
		</div>
		<div class="lanMuBox">
			<div
				class="lanMuItem supHove1"
				v-for="(item, index) in lanMuData"
				:key="index"
				@click="lanMuBtn(item.name)"
				:style="{ background: 'url(' + item.url + ')', 'background-size': '100% 100%' }"
			>
				<h2>{{ item.name }}</h2>
			</div>
		</div>
		<div class="kejBox">
			<div class="kejLeft">
				<div class="typeSysTit">
					<div class="typeSysTxt">
						<img src="@/assets/img/kej.svg" alt="" />
						<h3>每期课件</h3>
					</div>
					<div class="typeSysRigIcon supHove3" @click="tzBtn('kejianTj', { tabFtxt: '每期课件' })">
						<span>更多</span>
						<img src="@/assets/img/jr (3).svg" alt="" />
					</div>
				</div>
				<div class="kejgJ">
					<div class="kejCont">
						<div class="kejImg">
							<h2 :title="meiqiData?.title" @click="mqBtnFn(meiqiData?.title, meiqiData.coursewarePeriodId)">{{ meiqiData?.title }}</h2>
							<p>{{ (meiqiData?.releaseTime || meiqiData?.createTime) | momentYR }}发布</p>
							<div class="kejItxt supHove4" @click="mqBtnFn(meiqiData?.title, meiqiData.coursewarePeriodId)">
								<img :src="$imgUrl + meiqiData?.coverImg" alt="" />
								<div class="kejItxtC">
									<h3 :title="meiqiData?.title">{{ meiqiData?.title }}</h3>
									<span v-if="meiqiData">{{ (meiqiData?.updateTime) | momentYR('MM-DD') }} ({{ meiqiData?.updateTime | momentZ }}) 更新</span>
								</div>
							</div>
						</div>
						<div class="kejLook">
							<div class="kejLookTit">本期看点</div>
							<div class="kejLookArr" v-if="meiqiData" @click="mqBtnFn(meiqiData?.title, meiqiData.coursewarePeriodId)">
								<div class="kejLookItem" v-html="$txtGs(meiqiData?.content || '')" :title="$extractText($txtGs(meiqiData?.content || ''))"></div>
							</div>
							<div class="kejLookArr" v-else>
								<el-empty description="暂无看点"></el-empty>
							</div>
						</div>
					</div>
					<div class="kejRig">
						<div class="kejRigItem active" v-for="(item, index) in meiqiList" @click="mqBtnFn(item?.title, item.coursewarePeriodId)" :key="index">
							<div class="kejRigItemTit">
								<h4>{{ item?.title }}</h4>
								<span>{{ (item?.releaseTime || item?.createTime) | momentYR }}</span>
							</div>
							<div class="kejRigItemP" v-html="$extractText(item?.content || '')" :title="$extractText(item?.content || '')"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="kejRm">
				<div class="kejRmTit">
					<img src="@/assets/img/rmen.svg" alt="" />
					<h2>热门推荐</h2>
				</div>
				<div class="kejRmP" v-if="reMdata.length">
					<div class="kejRmItem" v-for="(item, index) in reMdata" :key="index" @click="remFn(item)">
						<div class="kejRmB" :style="{ background: ysArr[item.type - 1] }">
							{{ ysTxt[item.type - 1] }}
						</div>
						<div class="kejRmCont" :title="item?.title">
							{{ item?.title }}
						</div>
					</div>
				</div>
				<div class="kejRmP" v-if="!reMdata.length">
					<el-empty description="暂无推荐"></el-empty>
				</div>
			</div>
		</div>
		<div class="typeBox">
			<div class="typeSys">
				<div class="typeSysTit">
					<div class="typeSysTxt">
						<img src="@/assets/img/tb.svg" alt="" />
						<h3>同步课件</h3>
					</div>
					<div class="typeSysRigIcon supHove3" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 1, tabFtxt: '同步课件' })">
						<span>更多</span>
						<img src="@/assets/img/jr (3).svg" alt="" />
					</div>
				</div>
				<div class="typeSysCont" v-if="tobData.length">
					<div class="typeSysItem supHove5" v-for="(item, index) in tobData" :key="index" @click="btnFn(item, 1)">
						<div class="typeSysImg" style="width: 80px">
							<el-image :src="$imgFn(item.resourceFileName, 1)" lazy></el-image>
						</div>
						<div class="typeSysItemC">
							<div class="typeSysItemP" :title="item?.title">
								{{ item?.title }}
							</div>
							<div class="typeSysItemBot">
								<div class="typeSysItemXz">
									<img src="@/assets/img/xiazai.svg" alt="" />
									<span>下载量：{{ item.downloadNum || 0 }}</span>
								</div>
								<div class="typeSysItemTime">
									{{ (item?.releaseTime || item?.createTime) | momentYR('YYYY-MM-DD') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="typeSysCont" v-if="!tobData.length">
					<el-empty description="暂无课件"></el-empty>
				</div>
			</div>
			<div class="typeSys">
				<div class="typeSysTit">
					<div class="typeSysTxt">
						<img src="@/assets/img/sj.svg" alt="" />
						<h3>最新试卷</h3>
					</div>
					<div class="typeSysRigIcon supHove3" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 2, tabFtxt: '最新试卷' })">
						<span>更多</span>
						<img src="@/assets/img/jr (3).svg" alt="" />
					</div>
				</div>
				<div class="typeSysCont" v-if="xsjData.length">
					<div class="typeSysItem supHove5" v-for="(item, index) in xsjData" :key="index" @click="btnFn(item, 2)">
						<div class="typeSysImg" style="width: 80px">
							<el-image :src="$imgFn(item.resourceFileName, 1)" lazy></el-image>
						</div>
						<div class="typeSysItemC">
							<div class="typeSysItemP" :title="item?.title">
								{{ item?.title }}
							</div>
							<div class="typeSysItemBot">
								<div class="typeSysItemXz">
									<img src="@/assets/img/xiazai.svg" alt="" />
									<span>下载量：{{ item.downloadNum || 0 }}</span>
								</div>
								<div class="typeSysItemTime">
									{{ (item?.releaseTime || item?.createTime) | momentYR('YYYY-MM-DD') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="typeSysCont" v-if="!xsjData.length">
					<el-empty description="暂无试卷"></el-empty>
				</div>
			</div>
			<div class="typeSys" style="flex: 1">
				<div class="typeSysTit">
					<div class="typeSysTxt">
						<img src="@/assets/img/sy.svg" alt="" />
						<h3>双语新闻</h3>
					</div>
					<div class="typeSysRigIcon supHove3" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 8, treFlag: false, tabFtxt: '双语新闻' })">
						<span>更多</span>
						<img src="@/assets/img/jr (3).svg" alt="" />
					</div>
				</div>
				<div class="typeSysCont" v-if="syData.length">
					<div class="typeSysItem supHove5" v-for="(item, index) in syData" :key="index" @click="btnFn(item, 's')">
						<div class="typeSysImg" style="width: 120px">
							<el-image :src="$imgUrl + item?.coverImg" lazy></el-image>
						</div>
						<div class="typeSysItemC">
							<div class="typeSysItemP" :title="item?.title">
								{{ item?.title }}
							</div>
							<div class="typeSysItemBot">
								<div class="typeSysItemXz">
									<img src="@/assets/img/xiazai.svg" alt="" />
									<span>下载量：{{ item.downloadNum || 0 }}</span>
								</div>
								<div class="typeSysItemTime">
									{{ (item?.releaseTime || item?.createTime) | momentYR('YYYY-MM-DD') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="typeSysCont" v-if="!syData.length">
					<el-empty description="暂无新闻"></el-empty>
				</div>
			</div>
		</div>
		<div class="typeBox">
			<div class="typeSys" style="width: 274px">
				<div class="typeSysTit">
					<div class="typeSysTxt">
						<img src="@/assets/img/tinlike.svg" alt="" />
						<h3>听力课本</h3>
					</div>
					<div class="typeSysRigIcon supHove3" @click="tzBtn('tingliHome', { txt: '听力课本' })">
						<span>更多</span>
						<img src="@/assets/img/jr (3).svg" alt="" />
					</div>
				</div>
				<div v-if="tlData.length">
					<!-- @click="tlBtnFn(item)" -->
					<div v-for="(item, index) in tlData" class="supHove4" style="cursor: pointer" :key="index" @click="tzBtn('tingliHome', { txt: '听力课本' })">
						<div class="typeSys3Img">
							<el-image :src="$imgUrl + item?.coverImg" lazy></el-image>
						</div>
						<div class="typeSys3P" :title="item?.title">
							{{ item?.title }}
						</div>
					</div>
				</div>
				<div v-if="!tlData.length">
					<el-empty description="暂无听力"></el-empty>
				</div>
			</div>
			<div class="typeSys" style="flex: 1; margin: 0">
				<div class="typeSysTit">
					<div class="typeSysTxt">
						<img src="@/assets/img/yzke.svg" alt="" />
						<h3>优质课件</h3>
					</div>
					<div class="typeSysRigIcon supHove3" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 3, tabFtxt: '优质课件' })">
						<span>更多</span>
						<img src="@/assets/img/jr (3).svg" alt="" />
					</div>
				</div>
				<div class="typeSysCont typeSysCont4" v-if="yzkjData.length">
					<div class="typeSysItem supHove5" v-for="(item, index) in yzkjData" :key="index" @click="btnFn(item, 3)">
						<div class="typeSysImg">
							<el-image :src="$imgFn(item.resourceFileName, 1)" lazy></el-image>
						</div>
						<div class="typeSysItemC">
							<div class="typeSysItemP" :title="item?.title">
								{{ item?.title }}
							</div>
							<div class="typeSysItemBot">
								<div class="typeSysItemXz">
									<img src="@/assets/img/xiazai.svg" alt="" />
									<span>下载量：{{ item.downloadNum || 0 }}</span>
								</div>
								<div class="typeSysItemTime">
									{{ (item?.releaseTime || item?.createTime) | momentYR('YYYY-MM-DD') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="!yzkjData.length">
					<el-empty description="暂无优质课件"></el-empty>
				</div>
			</div>
		</div>
		<div class="jXSys">
			<div class="jXSysItem" v-for="i in 4" :key="i">
				<div class="typeSysTit">
					<div class="typeSysTxt">
						<img v-if="i == 1" src="@/assets/img/shuangy.svg" alt="" />
						<img v-if="i == 2" src="@/assets/img/ywxs.svg" alt="" />
						<img v-if="i == 3" src="@/assets/img/waikan.svg" alt="" />
						<img v-if="i == 4" src="@/assets/img/youzike.svg" alt="" />
						<h3>{{ i == 1 ? '双语节目' : i == 2 ? '英文小说' : i == 3 ? '荐阅外刊' : '优质课' }}</h3>
					</div>
					<div class="typeSysRigIcon supHove3" @click="tabFn(i)">
						<span>更多</span>
						<img src="@/assets/img/jr (3).svg" alt="" />
					</div>
				</div>
				<div class="jXSysCont">
					<div v-if="i == 1">
						<div class="jXSysP" v-for="(item, index) in syjmData" :key="index" @click="btnFn(item, 5)">
							<p :title="item?.title">{{ item?.title }}</p>
							<span>{{ (item?.releaseTime || item?.createTime) | momentYR('YYYY-MM-DD') }}</span>
						</div>
					</div>
					<div v-if="i == 2">
						<div class="jXSysP" v-for="(item, index) in ywxsData" :key="index" @click="btnFn(item, 6)">
							<p :title="item?.title">{{ item?.title }}</p>
							<span>{{ (item?.releaseTime || item?.createTime) | momentYR('YYYY-MM-DD') }}</span>
						</div>
					</div>
					<div v-if="i == 3">
						<div class="jXSysP" v-for="(item, index) in wkrwData" :key="index" @click="btnFn(item, 4)">
							<p :title="item?.title">{{ item?.title }}</p>
							<span>{{ (item?.releaseTime || item?.createTime) | momentYR('YYYY-MM-DD') }}</span>
						</div>
					</div>
					<div v-if="i == 4">
						<div class="jXSysP" v-for="(item, index) in yzkData" :key="index" @click="btnFn(item, 7)">
							<p :title="item?.title">{{ item?.title }}</p>
							<span>{{ (item?.releaseTime || item?.createTime) | momentYR('YYYY-MM-DD') }}</span>
						</div>
					</div>
					<div v-if="(i == 1 && !syjmData.length) || (i == 2 && !ywxsData.length) || (i == 3 && !wkrwData.length) || (i == 4 && !yzkData.length)" class="bbKbox">
						<el-empty description="暂无推荐"></el-empty>
					</div>
				</div>
			</div>
		</div>
		<div class="ztBoxs">
			<div class="ztLeft">
				<div class="ztHeader">
					<div class="ztHeaderImg supHove3" @click="tzBtn('zystHome', { txt: '高考真题' })">
						<p>
							高考真题
							<img src="@/assets/img/jr (1).svg" alt="" />
						</p>
						<span>TRUE QUESTION</span>
						<img src="@/assets/img/gkai.png" class="imgs" alt="" />
					</div>
					<div class="ztHeaderImg ztHeaderImg1 supHove3" @click="tzBtn('zystHome', { txt: '高频词汇', tabFlag: 2 })">
						<p>
							高频词汇
							<img src="@/assets/img/jr (1).svg" alt="" />
						</p>
						<span>TRUE QUESTION</span>
						<img src="@/assets/img/gpch.png" class="imgs" alt="" />
					</div>
				</div>
				<div class="ztFlB">
					<div
						class="ztFlItem"
						:title="item.classificationName"
						:class="{ active: item.classificationId == flags }"
						@click="tabBtnFn(item)"
						v-for="(item, index) in sxData"
						:key="index"
					>
						{{ item.classificationName }}
					</div>
				</div>
				<div class="ztCont" v-if="gkData.length">
					<p v-for="(item, index) in gkData" @click="gkbtnFn(item)" :key="index" :title="item?.title">{{ item?.title }}</p>
				</div>
				<div class="ztCont ztCont1" v-if="!gkData.length">
					<el-empty description="暂无试题"></el-empty>
				</div>
			</div>
			<div class="ztRight">
				<div class="typeSysTit">
					<div class="typeSysTxt">
						<img src="@/assets/img/mryt.svg" alt="" />
						<h3>每日一听</h3>
					</div>
					<div class="typeSysRigIcon supHove3" @click="tzBtn('gongxiangHz', { type: 2, classType: 9, tabFtxt: '每日一听' })">
						<span>更多</span>
						<img src="@/assets/img/jr (3).svg" alt="" />
					</div>
				</div>
				<div class="ztRigBox" v-if="mrytData.length">
					<div class="ztRigItem supHove4" v-for="(item, index) in mrytData" :key="index" @click="mrytBtn(item)">
						<div class="ztRigImg">
							<el-image :src="$imgFn('试卷', 2)" lazy></el-image>
						</div>
						<div class="ztRigCont">
							<div class="ztRigP" :title="item?.title">
								{{ item?.title }}
							</div>
							<div class="ztRigBot">
								<div class="ztRigBotItem">
									<img src="@/assets/img/shit.svg" alt="" />
									<span>试题数量：{{ item.questionNum }}题</span>
								</div>
								<div class="ztRigBotItem">
									<img src="@/assets/img/dati.svg" alt="" />
									<span>答题时间：{{ item.answerTime ? Math.floor(item.answerTime / 60) : '0' }}分钟</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="ztRigBox" v-if="!mrytData.length">
					<el-empty description="暂无推荐"></el-empty>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import lunbo from '@/components/pubComponents/lunbo';
import lanMu1 from '@/assets/img/lanMu1.png';
import lanMu2 from '@/assets/img/lanMu2.png';
import lanMu3 from '@/assets/img/lanMu3.png';
import lanMu4 from '@/assets/img/lanMu4.png';
import lanMu5 from '@/assets/img/lanMu5.png';
import lanMu6 from '@/assets/img/lanMu6.png';
import lanMu7 from '@/assets/img/lanMu7.png';
import lanMu8 from '@/assets/img/lanMu8.png';
import lanMu9 from '@/assets/img/lanMu9.png';
import lanMu10 from '@/assets/img/lanMu10.png';
import lanMu11 from '@/assets/img/lanMu11.png';
import lanMu12 from '@/assets/img/lanMu12.png';
import { mapState } from 'vuex';

export default {
	name: 'homE',
	data() {
		return {
			fullscreenLoading: false,
			tipFlag: false,
			bgImgs: [],
			ysArr: ['#FF9D32', '#5BCCBA', '#FD674A', '#7C7CFA'],
			ysTxt: ['歌', '演', '美', '电'],
			reMdata: [],
			tobData: [],
			xsjData: [],
			syData: [],
			tlData: [],
			yzkjData: [],
			yzkData: [],
			syjmData: [],
			ywxsData: [],
			wkrwData: [],
			flags: '',
			lanMuData: [
				{
					name: '听力课本',
					tip: '英语听力专业训练',
					url: lanMu1
				},
				{
					name: '高考真题',
					tip: '英语听力专业训练',
					url: lanMu2
				},
				{
					name: '教材同步',
					tip: '英语听力专业训练',
					url: lanMu3
				},
				{
					name: '双语新闻',
					tip: '英语听力专业训练',
					url: lanMu4
				},
				{
					name: '每日一听',
					tip: '英语听力专业训练',
					url: lanMu5
				},
				{
					name: '双语视频',
					tip: '英语听力专业训练',
					url: lanMu6
				},
				{
					name: '英文歌曲',
					tip: '英语听力专业训练',
					url: lanMu7
				},
				{
					name: '英文演讲',
					tip: '英语听力专业训练',
					url: lanMu8
				},
				{
					name: '荐阅外刊',
					tip: '英语听力专业训练',
					url: lanMu9
				},
				{
					name: '高频词汇',
					tip: '英语听力专业训练',
					url: lanMu10
				},
				{
					name: '优质课',
					tip: '英语听力专业训练',
					url: lanMu11
				},
				{
					name: '美文赏析',
					tip: '英语听力专业训练',
					url: lanMu12
				}
			],
			sxData: [],
			meiqiData: {}, // 每期课件
			meiqiList: [], // 每期课件 余下
			gkData: [],
			mrytData: [],
			bjData: '' // 班级信息
		};
	},
	computed: {
		...mapState(['infoData'])
	},
	components: {
		userHeader,
		foot,
		fuHeader,
		lunbo
	},
	methods: {
		mrytBtn(item) {
			this.$router.push({
				path: './timDec',
				query: {
					type: 1,
					txt: item?.title,
					crumFlag: 1,
					tabFtxt: ['首页', '每日一听'],
					listenEveryDayId: item.listenEveryDayId
				}
			});
		},
		gkbtnFn(item) {
			this.$router.push({
				path: './timDec',
				query: {
					type: 1,
					txt: item?.title,
					crumFlag: 1,
					tabFtxt: ['首页', '高考真题'],
					collegeExaminationId: item.collegeExaminationId
				}
			});
		},
		tabBtnFn(item) {
			if (this.flags == item.classificationId) {
				this.flags = '';
			} else {
				this.flags = item.classificationId;
			}
			this.gkFn();
		},
		remFn(item) {
			let a = ['首页'];
			if (item.type == 1) {
				a.push('歌曲列表');
			} else if (item.type == 2) {
				a.push('演讲列表');
			} else if (item.type == 3) {
				a.push('美文列表');
			} else if (item.type == 4) {
				a.push('电影列表');
			}
			this.$router.push({
				path: 'scDec',
				query: {
					type: item.type,
					crumFlag: 1,
					txt: item?.title,
					webpageResourceId: item.webpageResourceId,
					tabFtxt: a
				}
			});
		},
		tipBtn() {
			this.tipFlag = false;
		},
		tlBtnFn(item) {
			this.$router.push({
				path: './tingliDec',
				query: {
					txt: item?.title,
					tabFtxt: ['首页'],
					textbookId: item.textbookId
				}
			});
		},
		btnFn(item, type) {
			if (type == 's') {
				this.$router.push({
					path: 'scDec',
					query: {
						type: 2,
						flags: 1,
						crumFlag: 1,
						txt: item?.title,
						documentResourceId: item.documentResourceId,
						tabFtxt: ['首页', '双语新闻']
					}
				});
			} else {
				let a = ['首页'];
				if (type == 1) {
					a.push('同步课件');
				}
				if (type == 2) {
					a.push('最新试卷');
				}
				if (type == 3) {
					a.push('优质课件');
				}
				if (type == 5) {
					a.push('双语节目');
				}
				if (type == 6) {
					a.push('英文小说');
				}
				if (type == 4) {
					a.push('荐阅外刊');
				}
				if (type == 7) {
					a.push('优质课');
				}
				this.$router.push({
					path: './hbDec',
					query: {
						type: 5,
						flags: 1,
						conTxt: 1,
						txt: item?.title,
						classType: type,
						documentResourceId: item.documentResourceId,
						yzType: '1',
						crumFlag: 1,
						tabFtxt: a
					}
				});
			}
		},
		mqBtnFn(txt, id) {
			this.$router.push({
				path: './mqDec',
				query: {
					type: 1,
					crumFlag: 1,
					txt,
					coursewarePeriodId: id,
					tabFtxt: ['首页', '每期课件']
				}
			});
		},
		tabFn(i) {
			// 1双语节目 2英文小说 3荐阅外刊 4优质课
			if (i == 1) {
				this.tzBtn('gongxiangHz', { yzType: '2', classType: 5, treFlag: false, tabFtxt: '双语节目' });
			} else if (i == 2) {
				this.tzBtn('gongxiangHz', { yzType: '2', classType: 6, treFlag: false, tabFtxt: '英文小说' });
			} else if (i == 3) {
				this.tzBtn('gongxiangHz', { yzType: '2', classType: 4, treFlag: false, tabFtxt: '荐阅外刊' });
			} else {
				this.tzBtn('gongxiangHz', { yzType: '2', classType: 7, treFlag: false, tabFtxt: '优质课' });
			}
		},
		init() {
			this.fullscreenLoading = true;
			// 轮播图
			this.$http
				.get('api/app/yydBanner/list', {
					params: {
						type: 3
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.bgImgs = res.data;
					}
				});
			// 每期课件
			this.$http.get('api/app/yydCoursewarePeriod/list').then((res) => {
				if (res.code == 200) {
					if (res.rows) {
						this.meiqiData = res.rows[0];
						this.meiqiList = res.rows.slice(1, 5);
					}
				}
			});
			// 班级信息
			this.$http.get('api/app/yydBj/selectYydBjDefult').then((res) => {
				if (res.code == 200) {
					this.bjData = res.data;
				}
			});
			// 热门推荐
			this.$http
				.get('api/app/yydWebpageResource/list', {
					params: {
						recommended: 1,
						pageNum: 1,
						pageSize: 10
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.reMdata = res.rows;
					}
				});
			// 同步课件
			this.$http
				.get('api/app/yydDocumentResource/list', {
					params: {
						type: 1,
						sort: 2,
						pageNum: 1,
						pageSize: 3
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.tobData = res.rows;
					}
				});
			// 最新试卷
			this.$http
				.get('api/app/yydDocumentResource/list', {
					params: {
						type: 2,
						sort: 2,
						pageNum: 1,
						pageSize: 3
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.xsjData = res.rows;
					}
				});
			// 双语新闻
			this.$http
				.get('api/app/yydDocumentResource/list', {
					params: {
						type: 8,
						sort: 2,
						pageNum: 1,
						pageSize: 3
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.syData = res.rows;
					}
				});
			// 听力课
			this.$http.get('api/app/yydTextbook/list').then((res) => {
				if (res.code == 200) {
					this.tlData = res.rows.slice(0, 1);
				}
			});
			// 优质课件
			this.$http
				.get('api/app/yydDocumentResource/list', {
					params: {
						type: 3,
						sort: 2,
						pageNum: 1,
						pageSize: 6
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.yzkjData = res.rows;
					}
				});
			// 双语节目
			this.$http
				.get('api/app/yydDocumentResource/list', {
					params: {
						type: 5,
						sort: 2,
						pageNum: 1,
						pageSize: 4
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.syjmData = res.rows || [];
						this.total = res.total;
					}
				});
			// 英文小说
			this.$http
				.get('api/app/yydDocumentResource/list', {
					params: {
						type: 6,
						sort: 2,
						pageNum: 1,
						pageSize: 4
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.ywxsData = res.rows || [];
						this.total = res.total;
					}
				});
			// 荐阅外刊
			this.$http
				.get('api/app/yydDocumentResource/list', {
					params: {
						type: 4,
						sort: 1,
						pageNum: 1,
						pageSize: 4
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.wkrwData = res.rows || [];
						this.total = res.total;
					}
				});
			// 优质课
			this.$http
				.get('api/app/yydDocumentResource/list', {
					params: {
						type: 7,
						sort: 2,
						pageNum: 1,
						pageSize: 4
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.yzkData = res.rows || [];
						this.total = res.total;
					}
				});
			// 高考真题 筛选
			this.$http
				.get(`api/app/yydQuestionClassification/list`, {
					params: {
						categories: 6
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.sxData = res.data || [];
					}
				});
			// 每日一听
			this.$http
				.get('api/app/yydListenEveryDay/list', {
					params: {
						sort: 3,
						pageNum: 1,
						pageSize: 4
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.mrytData = res.rows || [];
					}
				});

			this.gkFn();
		},
		gkFn() {
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydCollegeExamination/list', {
					params: {
						provincesClassificationId: this.flags,
						pageNum: 1,
						pageSize: 14
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.gkData = res.rows || [];
					}
				});
		},
		lanMuBtn(name) {
			if (name == '听力课本') {
				this.tzBtn('tingliHome', { txt: '听力课本' });
			} else if (name == '高考真题') {
				this.tzBtn('zystHome', { txt: '高考真题' });
			} else if (name == '教材同步') {
				this.tzBtn('gongxiangHz', { yzType: '2', classType: 1, tabFtxt: '教材同步' });
			} else if (name == '双语新闻') {
				this.tzBtn('gongxiangHz', { yzType: '2', classType: 8, treFlag: false, tabFtxt: '双语新闻' });
			} else if (name == '每日一听') {
				this.tzBtn('gongxiangHz', { type: 2, classType: 9, tabFtxt: '每日一听' });
			} else if (name == '双语视频') {
				this.tzBtn('dianyingHome');
			} else if (name == '英文歌曲') {
				this.tzBtn('zlmwHome', {
					tabType: 1
				});
			} else if (name == '英文演讲') {
				this.tzBtn('zlmwHome', {
					tabType: 2
				});
			} else if (name == '高频词汇') {
				this.tzBtn('zystHome', { txt: '高频词汇', tabFlag: 2 });
			} else if (name == '荐阅外刊') {
				this.tzBtn('gongxiangHz', { yzType: '2', classType: 4, treFlag: false, tabFtxt: '荐阅外刊' });
			} else if (name == '优质课') {
				this.tzBtn('gongxiangHz', { yzType: '2', classType: 7, treFlag: false, tabFtxt: '优质课' });
			} else if (name == '美文赏析') {
				this.tzBtn('zlmwHome', {
					tabType: 3
				});
			}
		},
		tzBtn(type, qu) {
			sessionStorage.removeItem('classificationId');
			this.$router.push({
				path: type,
				query: {
					...qu
				}
			});
		},
		async zyFn() {
			// 小程序二维码
			await this.$http.get(`api/system/dict/data/config/app_mini_pic`).then((res) => {
				if (res.code == 200) {
					localStorage.setItem('appMiniPic', JSON.stringify(res.data));
					this.$store.commit('setAppMiniPic', res.data);
				}
			});
			// 公众号二维码
			await this.$http.get(`api/system/dict/data/config/app_weixin_official_accounts_pic`).then((res) => {
				if (res.code == 200) {
					localStorage.setItem('appWxOffic', JSON.stringify(res.data));
					this.$store.commit('setAppWxOffic', res.data);
				}
			});
			// 客服电话
			this.$http.get(`api/system/dict/data/config/app_service_phone`).then((res) => {
				if (res.code == 200) {
					localStorage.setItem('appPhone', JSON.stringify(res.data));
					this.$store.commit('setAppPhone', res.data);
				}
			});
			// 工作时间
			this.$http.get(`api/system/dict/data/config/app_service_time`).then((res) => {
				if (res.code == 200) {
					localStorage.setItem('appTime', JSON.stringify(res.data));
					this.$store.commit('setAppTime', res.data);
				}
			});
			// 公司logo
			await this.$http.get(`api/system/dict/data/config/app_logo`).then((res) => {
				if (res.code == 200) {
					localStorage.setItem('appLogo', JSON.stringify(res.data));
					this.$store.commit('setAppLogo', res.data);
				}
			});
			// 公司名称
			await this.$http.get(`api/system/dict/data/config/app_company`).then((res) => {
				if (res.code == 200) {
					localStorage.setItem('appCompany', JSON.stringify(res.data));
					this.$store.commit('setAppCompany', res.data);
				}
			});
			await this.$http.get(`api/system/dict/data/config/app_icp`).then((res) => {
				if (res.code == 200) {
					localStorage.setItem('icpData', JSON.stringify(res.data));
					this.$store.commit('setIcpData', res.data);
				}
			});
			await this.$http.get(`api/system/dict/data/config/app_gongan`).then((res) => {
				if (res.code == 200) {
					localStorage.setItem('gaData', JSON.stringify(res.data));
					this.$store.commit('setGaData', res.data);
				}
			});
			await this.$http
				.get('api/app/yydBanner/list', {
					params: {
						type: 6
					}
				})
				.then((res) => {
					if (res.code == 200) {
						localStorage.setItem('wjData', JSON.stringify(res.data));
					}
				});
			await this.$http
				.get('api/app/yydBanner/list', {
					params: {
						type: 7
					}
				})
				.then((res) => {
					if (res.code == 200) {
						localStorage.setItem('mtData', JSON.stringify(res.data));
					}
				});
		}
	},
	created() {
		this.zyFn();
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.lanMuBox {
	width: 1200px;
	margin: 20px auto 3.5px;
	display: flex;
	flex-wrap: wrap;
	.lanMuItem {
		width: 186px;
		height: 110px;
		color: #fff;
		box-sizing: border-box;
		margin-right: 16.5px;
		margin-bottom: 16.5px;
		border-radius: 12px;
		// display: flex;
		// align-items: center;
		cursor: pointer;

		&:nth-of-type(6n) {
			margin-right: 0;
		}
		h2 {
			font-size: 28px;
			width: 100%;
			margin-top: 16px;
			text-align: center;
			letter-spacing: 4px;
			line-height: 1.3;
			font-weight: bold;
		}
		p {
			font-size: 12px;
			margin-top: 4px;
		}
	}
}
.searBox {
	display: flex;
	width: 1200px;
	margin: 0 auto;
	.searBoxCont {
		flex: 1;
		padding: 10px 0 0;
	}
	.searBoxRig {
		margin-left: 10px;
		width: 270px;
		padding-top: 10px;
		.searBoxRigXin {
			border-radius: 4px;
			background: #ffffff;
			display: flex;
			align-items: center;
			padding: 0 16px 0 18px;
			color: #000000;
			font-size: 18px;
			height: 66px;
			margin-bottom: 10px;
			cursor: pointer;
			.icon {
				width: 24px;
				height: 24px;
				margin-right: 13px;
			}
			p {
				flex: 1;
				font-size: 18px;
			}
			.iconX {
				width: 19px;
				height: 19px;
			}
		}
		.searBoxRigCont {
			padding: 10px 10px 14px;
			background: #fff;
			color: #fff;

			.searBoxRigNrBot {
				border-radius: 0px 0px 4px 4px;
				height: 41px;
				background: rgba(255, 255, 255, 0.6);
				display: flex;
				align-items: center;
				padding: 0 16px;
				width: 100%;
				box-sizing: border-box;
				i {
					font-size: 18px;
					margin-right: 8px;
					line-height: 1.2;
				}
				span {
					font-size: 12px;
				}
				p {
					flex: 1;
					font-size: 16px !important;
					margin: 0 !important;
					padding: 0 !important;
					text-align: right;
					span {
						font-size: 12px;
						margin: 0 !important;
					}
				}
			}
			.searBoxRigBot {
				margin-top: 11px;
				height: 45px;
				border-radius: 4px;
				border: 1px solid #1d7b3a;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #1d7b3a;
				font-size: 14px;
				cursor: pointer;
				i {
					font-size: 15px;
					font-weight: bold;
					margin-right: 6px;
				}
				&:hover {
					background: #1d7b3a;
					color: #fff;
				}
			}
			.bjBox {
				height: 156px;
				::v-deep .el-empty {
					padding: 10px 0;
				}
			}
			.searBoxRigNr {
				height: 156px;
				background: url('@/assets/img/bg.png') 100% 100%;
				position: relative;
				.searBoxRigNrBot {
					position: absolute;
					bottom: 0;
				}

				.searBoxTit {
					display: flex;
					align-items: center;
					padding: 7px 7px 0 11px;
					justify-content: space-between;
					p {
						font-size: 16px;
						margin: 0;
						padding: 0;
					}
					img {
						width: 19px;
						height: 19px;
						cursor: pointer;
					}
				}
				p {
					padding: 0 7px 0 11px;
					margin-top: 8px;
					font-size: 12px;
					span {
						margin-right: 19px;
					}
				}
			}
		}
	}
	.searBoxLeft {
		width: 210px;
		margin-right: 10px;
		background: #fff;
		padding: 0 8px 8px;
		border-radius: 0px 0px 4px 4px;
		height: 322px;
		box-sizing: border-box;
		position: relative;
		.kzydBox {
			position: relative;
			&:hover {
				.searBoxTips {
					display: block;
				}
			}
		}
		.searBoxTips {
			position: absolute;
			display: none;
			top: 100%;
			left: -10px;
			padding-left: 0;
			z-index: 99;
			.line {
				height: 10px;
			}
			.arrow {
				width: 8px;
				height: 8px;
				border: 1px solid #ccc;
				background-color: #fff;
				position: absolute;
				top: 8px;
				left: 50%;
				transform: rotate(45deg) translateX(-50%);
				border-bottom: none;
				border-right: none;
			}
		}
		.searBoxTip {
			width: auto;
			background: #fff;
			height: auto;
			border-radius: 4px;
			border: 1px solid #ccc;
			div {
				color: #666666;
				font-size: 14px;
				cursor: pointer;
				padding: 8px 10px;
				white-space: nowrap;
				&:hover {
					color: #1d7b3a;
				}
			}
		}
		.searBoxItem {
			padding: 14px 0 0;
			border-bottom: 1px solid #f3f4f7;
			&:last-of-type {
				border-bottom: none;
			}
			.searBoxTop {
				display: flex;
				align-items: center;
				font-size: 16px;
				color: #000000;
				font-weight: bold;
				img {
					width: 20px;
					height: 20px;
					margin-right: 5px;
				}
			}
			.searBoxBot {
				padding: 13px 2px 0;
				display: flex;
				flex-wrap: wrap;
				color: #666666;
				font-size: 14px;
				span {
					cursor: pointer;
					margin-right: 10px;
					margin-bottom: 13px;
					&:hover {
						color: #1d7b3a;
					}
					&:nth-of-type(3n) {
						margin-right: 0;
					}
				}
			}
			.searBoxBot1 {
				span {
					margin-right: 10px !important;
				}
			}
		}
	}
}
.ztBoxs {
	width: 1200px;
	margin: 0 auto 21px;
	display: flex;
	.ztRight {
		width: 453px;
		background: #ffffff;
		border-radius: 4px;
		padding: 0 20px;
		overflow-y: auto;
		.ztRigBox {
			.ztRigItem {
				display: flex;
				padding: 10px 5px;
				border-bottom: 1px solid #f8f8f8;
				cursor: pointer;
				&:last-of-type {
					border: none;
				}
				&:hover {
					.ztRigP {
						color: #1d7b3a;
					}
				}
				.ztRigImg {
					width: 92px;
					height: 92px;
					margin-right: 14px;
				}
				.ztRigCont {
					flex: 1;
					display: flex;
					justify-content: center;
					flex-direction: column;
					.ztRigP {
						font-size: 16px;
						color: #000000;
						margin-bottom: 16px;
						padding-right: 10px;
						// 超出多行省略号
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						text-overflow: ellipsis;
					}
					.ztRigBot {
						display: flex;
						.ztRigBotItem {
							display: flex;
							align-items: center;
							color: #333333;
							font-size: 12px;
							margin-right: 20px;
							img {
								width: 16px;
								height: 16px;
								margin-right: 2px;
							}
						}
					}
				}
			}
		}
	}
	.ztLeft {
		padding: 20px 20px 0;
		border-radius: 4px;
		background: #fff;
		margin-right: 10px;
		min-height: 350px;
		flex: 1;
		.ztHeader {
			margin-bottom: 30px;
			display: flex;
			justify-content: space-between;
			.ztHeaderImg {
				height: 87px;
				width: 335px;
				background: #423a99;
				box-shadow: 0px 7px 9px 0px #c7c3f1;
				border-radius: 8px;
				position: relative;
				display: flex;
				flex-direction: column;
				justify-content: center;
				box-sizing: border-box;
				padding-left: 38px;
				margin-right: 25px;
				cursor: pointer;
				&:last-of-type {
					margin-right: 0;
				}
				p {
					color: #ffffff;
					font-size: 18px;
					margin-bottom: 7px;
					display: flex;
					align-items: center;
					img {
						width: 16px;
						height: 16px;
						margin-left: 12px;
					}
				}
				span {
					font-size: 14px;
					color: #b3aee6;
				}
				.imgs {
					width: 84px;
					height: 87px;
					position: absolute;
					top: 0;
					right: 29px;
				}
			}
			.ztHeaderImg1 {
				background: #14757c;
				box-shadow: 0px 7px 9px 0px rgba(20, 117, 124, 0.29);
				span {
					color: #81c9ce;
				}
			}
		}
		.ztFlB {
			display: flex;
			flex-wrap: wrap;
			.ztFlItem {
				width: 77px;
				height: 36px;
				text-align: center;
				line-height: 36px;
				font-size: 14px;
				color: #000000;
				border-radius: 4px;
				background: #f3f4f7;
				margin: 0 25px 15px 0;
				padding: 0 4px;
				box-sizing: border-box;
				cursor: pointer;
				overflow: hidden; /* 确保超出容器的内容被裁剪 */
				white-space: nowrap; /* 确保文本在一行内显示 */
				text-overflow: ellipsis; /* 超出部分显示省略号 */
				&:nth-of-type(7n) {
					margin: 0;
				}
			}
			.active {
				background: #e5f2e9;
				color: #1d7b3a;
			}
		}
		.ztCont {
			padding: 15px 0 0;
			display: flex;
			flex-wrap: wrap;
			p {
				height: auto;
				width: 50%;
				overflow: hidden; /* 确保超出容器的内容被裁剪 */
				white-space: nowrap; /* 确保文本在一行内显示 */
				text-overflow: ellipsis; /* 超出部分显示省略号 */
				box-sizing: border-box;
				padding-right: 10px;
				margin-bottom: 18px;
				font-size: 16px;
				color: #000000;
				padding-left: 15px;
				position: relative;
				cursor: pointer;
				&:hover {
					color: #1d7b3a;
					&::before {
						background: #1d7b3a;
					}
				}
				&::before {
					content: '';
					width: 4px;
					height: 4px;
					border-radius: 50%;
					position: absolute;
					top: 50%;
					left: 0;
					transform: translateY(-50%);
					background: #000000;
				}
			}
		}
		.ztCont1 {
			justify-content: center;
		}
	}
}
.jXSys {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-wrap: wrap;
	.jXSysItem {
		width: calc((100% - 10px) / 2);
		height: 220px;
		background: #fff;
		box-sizing: border-box;
		margin-right: 10px;
		margin-bottom: 10px;
		border-radius: 4px;
		padding: 0 17px;
		&:nth-of-type(2n) {
			margin-right: 0;
		}
		.jXSysCont {
			padding-top: 14px;
			.jXSysP {
				display: flex;
				align-items: center;
				font-size: 16px;
				color: #000000;
				justify-content: space-between;
				margin-bottom: 15px;
				cursor: pointer;
				&:hover {
					color: #1d7b3a;
					span {
						color: #1d7b3a;
					}
					p {
						&::before {
							background: #1d7b3a;
						}
					}
				}
				p {
					flex: 1;
					padding-right: 20px;
					padding-left: 17px;
					position: relative;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
					&::before {
						content: '';
						width: 4px;
						height: 4px;
						border-radius: 50%;
						position: absolute;
						top: 50%;
						left: 0;
						transform: translateY(-50%);
						background: #000000;
					}
				}
				span {
					color: #8f9190;
					font-size: 12px;
				}
			}
		}
	}
}
.typeBox {
	width: 1200px;
	margin: 10px auto;
	display: flex;
	.typeSys {
		width: 353px;
		padding: 0 15px 13px;
		background: #ffffff;
		border-radius: 4px;
		margin-right: 10px;
		box-sizing: border-box;

		&:nth-of-type(3n) {
			margin-right: 0;
		}
		.typeSys3Img {
			height: 300px;
			img {
				border-radius: 6px;
			}
		}
		.typeSys3P {
			margin-top: 24px;
			color: #000000;
			font-size: 16px;
			width: 240px;
			overflow: hidden; /* 确保超出容器的内容被裁剪 */
			white-space: nowrap; /* 确保文本在一行内显示 */
			text-overflow: ellipsis; /* 超出部分显示省略号 */
		}
		.typeSysCont {
			.typeSysItem {
				padding: 20px 0;
				display: flex;
				cursor: pointer;
				&:hover {
					.typeSysItemP {
						color: #1d7b3a !important;
					}
				}
				.typeSysImg {
					height: 80px;
					width: 80px;
					margin-right: 12px;
				}
				.typeSysItemC {
					padding-right: 6px;
					flex: 1;
					display: flex;
					flex-direction: column;
					justify-content: center;
					.typeSysItemP {
						font-size: 16px;
						color: #000000;
						margin-bottom: 12px;
						// 超出多行省略号
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						text-overflow: ellipsis;
					}
					.typeSysItemBot {
						display: flex;
						justify-content: space-between;
						color: #8f9190;
						font-size: 12px;
						.typeSysItemXz {
							display: flex;
							align-items: center;
						}
						img {
							width: 12px;
							height: 13px;
							margin-right: 6px;
						}
					}
				}
			}
		}
		.typeSysCont4 {
			display: flex;
			flex-wrap: wrap;
			.typeSysItem {
				margin-right: 56px;
				width: calc((100% - 56px) / 2);
				&:nth-of-type(2n) {
					margin-right: 0;
				}
				.typeSysItemC {
					display: flex;
					flex-direction: column;
					justify-content: center;
				}
			}
		}
	}
}
.kejBox {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	.kejRm {
		width: 290px;
		margin-left: 10px;
		border-radius: 4px;
		background: #ffffff;
		box-sizing: border-box;
		padding: 0 15px;
		box-sizing: border-box;
		.kejRmTit {
			height: 58px;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #f8f8f8;
			img {
				width: 30px;
				height: 30px;
				margin-right: 4px;
			}
			h2 {
				color: #000000;
				font-size: 18px;
				font-weight: bold;
			}
		}
		.kejRmP {
			padding-top: 17px;
			.kejRmItem {
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				margin-right: 11px;
				cursor: pointer;
				&:hover {
					color: #1d7b3a;
				}
				.kejRmB {
					width: 27px;
					height: 27px;
					margin-right: 11px;
					border-radius: 4px;
					text-align: center;
					line-height: 27px;
					color: #fff;
					background: #7c7cfa;
					font-size: 16px;
				}
				.kejRmCont {
					font-size: 14px;
					flex: 1;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
				}
			}
		}
	}
	.kejLeft {
		flex: 1;
		background: #fff;
		border-radius: 4px;
		padding: 0 20px 0 16px;
		.kejgJ {
			display: flex;
			min-height: 480px;
			padding-top: 7px;
			box-sizing: border-box;
			.kejCont {
				width: 280px;
				margin-right: 66px;
				.kejImg {
					height: 230px;
					position: relative;
					background: url('@/assets/img/bg (1).png') 100% 100% no-repeat;
					padding: 11px 16px;
					box-sizing: border-box;
					h2 {
						font-size: 16px;
						font-weight: bold;
						color: #000000;
						width: 245px;
						overflow: hidden; /* 确保超出容器的内容被裁剪 */
						white-space: nowrap; /* 确保文本在一行内显示 */
						text-overflow: ellipsis; /* 超出部分显示省略号 */
						cursor: pointer;
					}
					p {
						font-size: 12px;
						color: #8f9190;
						margin-top: 9px;
					}
					.kejItxt {
						position: absolute;
						width: calc(100% - 16px);
						height: 78px;
						background: #fff;
						border-radius: 4px;
						left: 8px;
						bottom: 15px;
						display: flex;
						box-sizing: border-box;
						padding: 8px 7px 10px;
						cursor: pointer;
						img {
							width: 100px;
							height: 60px;
							margin-right: 12px;
							border-radius: 6px;
						}
						.kejItxtC {
							display: flex;
							flex-direction: column;
							justify-content: center;
							padding: 10px 0;
							h3 {
								font-size: 14px;
								color: #000000;
								width: 138px;
								font-weight: bold;
								overflow: hidden; /* 确保超出容器的内容被裁剪 */
								white-space: nowrap; /* 确保文本在一行内显示 */
								text-overflow: ellipsis; /* 超出部分显示省略号 */
							}
							span {
								margin-top: 6px;
								color: #8f9190;
								font-size: 12px;
							}
						}
					}
				}
				.kejLook {
					margin-top: 25px;
					padding-bottom: 12px;
					.kejLookTit {
						font-size: 16px;
						color: #000000;
						margin-bottom: 24px;
						font-weight: bold;
					}
					.kejLookArr {
						color: #333333;
						font-size: 14px;
						.kejLookItem {
							// 超出多行省略号
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 5;
							overflow: hidden;
							text-overflow: ellipsis;
							cursor: pointer;
							line-height: 1.4;

							&:hover {
								color: #1d7b3a;
							}
							&::v-deep p {
								width: 280px;
								overflow: hidden; /* 确保超出容器的内容被裁剪 */
								white-space: nowrap; /* 确保文本在一行内显示 */
								text-overflow: ellipsis; /* 超出部分显示省略号 */
							}
						}
					}
				}
			}
			.kejRig {
				flex: 1;
				.kejRigItem {
					padding: 10px 0;
					border-bottom: 1px solid #f8f8f8;
					cursor: pointer;
					&:last-of-type {
						border: none;
					}
					&:hover {
						.kejRigItemTit h4 {
							color: #1d7b3a;
						}
						.kejRigItemP {
							color: #1d7b3a;
						}
					}
					.kejRigItemTit {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-bottom: 12px;
						h4 {
							font-size: 16px;
							color: #000000;
							font-weight: bold;
						}
						span {
							font-size: 12px;
							color: #8f9190;
						}
					}
					.kejRigItemP {
						font-size: 12px;
						color: #333333;
						&::v-deep p {
							width: 500px;
							overflow: hidden; /* 确保超出容器的内容被裁剪 */
							white-space: nowrap; /* 确保文本在一行内显示 */
							text-overflow: ellipsis; /* 超出部分显示省略号 */
						}
					}
				}
			}
		}
	}
}
.typeSysTit {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 58px;
	border-bottom: 1px solid #f8f8f8;
	.typeSysTxt {
		color: #000000;
		font-size: 18px;
		display: flex;
		align-items: center;
		h3 {
			font-weight: bold;
		}
		img {
			width: 30px;
			height: 30px;
			margin-right: 6px;
		}
	}
	.typeSysRigIcon {
		font-size: 14px;
		color: #ababab;
		cursor: pointer;
		img {
			widows: 8px;
			height: 12px;
			margin-left: 5px;
			margin-bottom: -1px;
		}
	}
}
.bbKbox {
	::v-deep .el-empty {
		padding: 0;
		.el-empty__image {
			width: 70px;
		}
	}
}
</style>
